

import { forwardRef } from "react";
import type { ComponentPropsWithoutRef, ElementRef } from "react";
import {
  CheckIcon,
  MinusIcon,
} from '@phosphor-icons/react'
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { cn } from "@/lib/utils"

interface CheckboxProps extends ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  indeterminate?: boolean;
}

const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, indeterminate, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 border-2 border-border bg-background shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary",
      "hover:border-primary/60 transition-all duration-150",
      indeterminate && "bg-primary text-primary-foreground border-primary",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
      forceMount={indeterminate ? true : undefined}
    >
      {indeterminate ? (
        <MinusIcon className="h-3.5 w-3.5 stroke-2" />
      ) : (
        <CheckIcon className="h-3.5 w-3.5 stroke-2" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
